export const calculatePieChartTotalValue = ({
  values,
}: Widgets.PieChart.Item): number =>
  values.reduce((acc, { value }) => acc + value, 0);

export const calculatePieChartTotalAdditionalValue = ({
  values,
}: Widgets.PieChart.Item): number =>
  values.reduce((acc, { additionalValue = 0 }) => acc + additionalValue, 0);
